import {JobLog} from './JobLog';
import {selectedRowDetails} from './selectedRowDetails';

export class ViewLog {
  dataLog: string[];
  jobDetails: string;
  rowData: JobLog;
  selectedRowDetail: selectedRowDetails;
}